import React from "react";
import Slider from "react-slick";
import personJ from "../components/assets/images/Cases/jorge.webp";
import personLeo from "../components/assets/images/Cases/leonor.webp";
import personJLesl from "../components/assets/images/Cases/lesly.webp";
import personMaria from "../components/assets/images/Cases/brenda-cruz.webp";
import personCarlos from "../components/assets/images/Cases/keyris-espinoza.webp";
import personAna from "../components/assets/images/Cases/enrique-sanchez.webp";
import personManuel1 from "../components/assets/images/Cases/sarai.jpeg";
import personManuel2 from "../components/assets/images/Cases/ariana.png";

// Paleta institucional
const COLORS = {
  red: "#B71C1C",
  blue: "#0B3D91",
  yellow: "#D4A017",
  grayBg: "#F8F9FA",
  text: "#374151",
};

// Card Testimonial
const TestimonialCard = ({ imgSrc, name, position, stars, review }) => {
  return (
    <div className="px-3">
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm h-full p-6">
        {/* Encabezado */}
        <div className="flex items-center gap-4">
          <img
            src={imgSrc}
            alt={name}
            className="w-14 h-14 rounded-full object-cover border"
            style={{ borderColor: COLORS.blue }}
          />

          <div>
            <h4
              className="text-sm font-bold uppercase tracking-wide"
              style={{ color: COLORS.blue }}
            >
              {name}
            </h4>

            <p className="text-xs text-gray-500 mt-1">{position}</p>
          </div>
        </div>

        {/* Calificación */}
        <div className="flex gap-1 mt-4">
          {[...Array(5)].map((_, i) => (
            <svg
              key={i}
              className="w-4 h-4"
              viewBox="0 0 14 13"
              fill={i < stars ? COLORS.yellow : "#D1D5DB"}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M7 0L9.4687 3.60213L13.6574 4.83688L10.9944 8.29787L11.1145 12.6631L7 11.2L2.8855 12.6631L3.00556 8.29787L0.342604 4.83688L4.5313 3.60213L7 0Z" />
            </svg>
          ))}
        </div>

        {/* Comentario */}
        <p
          className="text-sm leading-relaxed mt-4"
          style={{ color: COLORS.text }}
        >
          {review}
        </p>
      </div>
    </div>
  );
};

// Main Component
const Testimonials = () => {
  const testimonials = [
    {
      imgSrc: personJLesl,
      name: "LESLY MARCHAN",
      position: "Agente de Turismo",
      stars: 5,
      review:
        "Recibí una sólida preparación académica respaldada por docentes comprometidos con la excelencia profesional.",
    },
    {
      imgSrc: personJ,
      name: "JORGE CHINCHAY",
      position: "Jefe de Cocina",
      stars: 5,
      review:
        "Mi formación en Cevatur fortaleció mis competencias y consolidó mi desarrollo en el sector gastronómico.",
    },
    {
      imgSrc: personLeo,
      name: "LEONOR AGUIRRE",
      position: "Asesora de Viajes Corporativos",
      stars: 5,
      review:
        "La experiencia académica me permitió ampliar conocimientos y proyectar una exitosa carrera profesional.",
    },
    {
      imgSrc: personMaria,
      name: "BRENDA CRUZ CRUZ",
      position: "Agente de Tráfico",
      stars: 5,
      review:
        "La calidad educativa recibida me brindó las herramientas necesarias para incorporarme con éxito al mercado laboral.",
    },
    {
      imgSrc: personCarlos,
      name: "KEIRIS ESPINOZA",
      position: "Oficial AVSEC",
      stars: 5,
      review:
        "Valoro profundamente la orientación académica y el acompañamiento constante durante mi etapa formativa.",
    },
    {
      imgSrc: personAna,
      name: "ENRIQUE SANCHES GARCIA",
      position: "Oficial AVSEC",
      stars: 5,
      review:
        "La preparación obtenida en Aviación Comercial fue determinante para alcanzar mis objetivos profesionales.",
    },
    {
      imgSrc: personManuel1,
      name: "SARAI CÓRDOVA CHANDUVI",
      position: "CEO de Sahara Travel",
      stars: 5,
      review:
        "Estudiar Aviación Comercial en Cevatur Piura, me brindó los conocimientos y herramientas que hoy aplico en mi vida profesional. Gracias a esta formación, tuve la oportunidad de emprender y fundar Sahara Travel, una agencia de viajes.",
    },
    {
      imgSrc: personManuel2,
      name: "ARIANA CALLE LOPEZ",
      position: "Oficial AVSEC",
      stars: 5,
      review:
        "Hola soy Ariana, egresada de Cevatur, Gracias a la calidad de Cevatur Piura pude aquirir las habilidades necesarias para destacarme en mi carrera de Aviación Comercial.",
    },

  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section
      className="py-16"
      style={{ backgroundColor: COLORS.grayBg }}
      data-aos="fade-up"
    >
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-14">
          <h2
            className="text-4xl font-bold"
            style={{ color: COLORS.red }}
          >
            Casos de Éxito
          </h2>

          <div
            className="w-24 h-1 mx-auto my-4 rounded-full"
            style={{ backgroundColor: COLORS.yellow }}
          ></div>

          <h3
            className="text-xl font-semibold"
            style={{ color: COLORS.blue }}
          >
            Testimonios de Nuestros Egresados
          </h3>

          <p
            className="max-w-3xl mx-auto mt-5 leading-relaxed text-base"
            style={{ color: COLORS.text }}
          >
            La trayectoria de nuestros egresados refleja el compromiso
            institucional con una formación académica de alto nivel, orientada
            al liderazgo, la empleabilidad y el desarrollo profesional
            sostenible.
          </p>
        </div>

        {/* Slider */}
        <Slider {...settings}>
          {testimonials.map((item, index) => (
            <TestimonialCard key={index} {...item} />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;